document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('#c-m-header-id > store-header');
    const mainContent = document.querySelector('main'); // Adjust the selector for your main content area if needed

    if (!header) {
        console.error('Header element not found. Ensure that the selector "#c-m-header-id > store-header" is correct.');
        return;
    }

    if (!mainContent) {
        console.error('Main content area not found. Ensure that the selector "main" is correct.');
        return;
    }

    function updateMainContentPadding() {
        const headerHeight = header.offsetHeight;
        console.log(`Header height: ${headerHeight}px`);
        
        // Apply padding to main content
        mainContent.style.paddingTop = `${headerHeight}px`;
    }

    // Call the function on load and window resize
    updateMainContentPadding();
    window.addEventListener('resize', updateMainContentPadding);
});
